import UploadInputArea from './UploadInputArea'

export default function UploadSection() {
  return (
    <section className="mb-12">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-white mb-2">
          Upload Documents
        </h2>
        <p className="text-slate-400 text-base">
          Chat with our AI to upload and process your documents. Supported formats: PDF, JPG, PNG
        </p>
      </div>

      <UploadInputArea />
    </section>
  )
}
